var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBookmarksSimple = function SvgIconBookmarksSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.625 1.625a1 1 0 0 0 0 2h9.5v14a1 1 0 1 0 2 0V3.375a1.75 1.75 0 0 0-1.75-1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 5.375a1.75 1.75 0 0 0-1.75 1.75v14.25a1 1 0 0 0 1.581.814l4.669-3.335 4.669 3.335a1 1 0 0 0 1.581-.814V7.125a1.75 1.75 0 0 0-1.75-1.75zm.25 14.057V7.375h8.5v12.057l-3.669-2.62a1 1 0 0 0-1.162 0z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBookmarksSimple;